import React from 'react';
import { connect } from 'react-redux';
import style from './SpeedText.css';

const SpeedText = ({ speed }) => <span className={style.speedValue}>{speed}x</span>;

function mapStateToProps(state) {
  return { speed: state.clock.speed };
}

export default connect(mapStateToProps)(SpeedText);
